import {
  GridPresetWideListLeftContent,
  GridPresetWideListRightContent,
  GridRow,
  HideFor,
  Picture,
} from "/App.Components";
import { PictureProps } from "/Models/Generated/PictureProps";
import "./ListItem.scss";
import { ReactNode } from "react";
import { LinkProps } from "/Models/Generated/LinkProps";
import { DesignTheme } from "/Models/Generated/DesignTheme";
import { TagsProps } from "/Models/Generated/TagsProps";
import Tags from "/Components/Blocks/Tags/Tags";
import { createSpreadableBem } from "/Helpers/createBem";

export interface ListItemMetadata {
  firstRow: ReactNode;
  secondRow?: ReactNode;
}

export interface ListItemProps {
  link?: LinkProps;
  image?: PictureProps;
  heading?: string;
  label?: string;
  metadataItems?: ListItemMetadata;
  published?: string;
  theme?: DesignTheme;
  categoryTags?: TagsProps;
}

const ListItem: React.FC<ListItemProps> = ({
  link,
  image,
  heading,
  label,
  metadataItems,
  published,
  theme,
  categoryTags,
}) => {
  const metadata = metadataItems && Object.keys(metadataItems).length > 0;

  const bem = createSpreadableBem("list-item-norad");
  return (
    <>
      <li
        {...bem("", {
          "--insight": theme === DesignTheme.Insight,
        })}
      >
        <a
          href={link?.href}
          target={link?.target}
          {...bem("__link")}
        >
          {/* ^ replace with link */}
          <GridRow>
            <GridPresetWideListLeftContent>
              {image && (
                <div {...bem("__image")}>
                  <Picture
                    {...image}
                    pictureAspectRatio="67/50"
                    pictureBehaviour="Cover"
                    noAlt
                  />
                </div>
              )}
            </GridPresetWideListLeftContent>
            <GridPresetWideListRightContent reverseOrderOn="mobile">
              <div
                {...bem("__content", {
                  "--insight": theme === DesignTheme.Insight,
                })}
              >
                {theme === DesignTheme.Insight && published && (
                  <p {...bem("__published")}>{published}</p>
                )}
                {label && <p {...bem("__label")}>{label}</p>}
                <h3 {...bem("__heading")}>
                  <span>{heading}</span>
                </h3>
                {theme === DesignTheme.Insight && categoryTags && (
                  <Tags {...categoryTags} />
                )}

                {theme !== DesignTheme.Insight && metadata && (
                  <div {...bem("__metadata")}>
                    {metadataItems.firstRow && (
                      <div {...bem("__metadata__row-1")}>
                        {metadataItems.firstRow}
                      </div>
                    )}
                    {metadataItems.secondRow && (
                      <div {...bem("__metadata__row-2")}>
                        {metadataItems.secondRow}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </GridPresetWideListRightContent>
          </GridRow>
        </a>
      </li>
      <HideFor desktop desktopMedium desktopLargeUp wrapperTag={"li"}>
        <div
          {...bem("__divider", { "--insight": theme === DesignTheme.Insight })}
        ></div>
      </HideFor>
    </>
  );
};

export default ListItem;
